<template>
  <div>


    <div class="questionnaire-header">
      <div class="col-10">
        <div class="questionnaire-header-title">Expression</div>
      </div>
      <div class="col-2 questionnaire-header-logo"><img src="@/assets/img/logo.png"></div>
    </div>


    <div v-if="isTestAudioVisible" class="questionnaire-info">
      <p>Cliquez sur l'icône "son" ci-dessous.<br>Si vous entendez clairement l'énoncé, vous pouvez débuter le test.</p>
    </div>
    <div v-else class="questionnaire-info">
      <p>Mettez-vous dans de bonnes conditions avant de commencer le test (de nombreuses questions fonctionnent avec un audio à écouter). <br>Une fois les {{ time }} minutes écoulées, vous ne pourrez plus accéder au test. </p>
      <p>Vous avez la possibilité de revenir sur les questions dans le temps imparti. </p>
    </div>

    <div v-if="isTestAudioVisible">
      <div class="questionnaire-section">
        <div class="questionnaire-question-image" @click.prevent="playSound()">
          <img src="@/assets/img/listen.png">
        </div>
      </div>

      <div class="questionnaire-section-action">
        <div class="questionnaire-section-action-button">
          <button :disabled="isDisabled" class="btn btn-primary btn-block" @click="debuter">
            <span>Commencer le test</span>
          </button>
        </div>
      </div>
    </div>
    <div v-else class="questionnaire-section">
      <div class="questionnaire-section-header">
        <div class="questionnaire-section-header-main">Test d'expression</div>
        <div class="questionnaire-section-header-sub">{{ time }} minutes</div>
      </div>

      <div class="questionnaire-section-content">
        <div class="questionnaire-section-content-domain">
          <div class="questionnaire-section-content-domain-name">Orthographe Vocabulaire</div>
          <div class="questionnaire-section-content-domain-time">8 questions</div>
        </div>
        <div class="questionnaire-section-content-domain">
          <div class="questionnaire-section-content-domain-name">Grammaire Syntaxe</div>
          <div class="questionnaire-section-content-domain-time">8 questions</div>
        </div>
        <div class="questionnaire-section-content-domain">
          <div class="questionnaire-section-content-domain-name">Compréhension écrite</div>
          <div class="questionnaire-section-content-domain-time">8 questions</div>
        </div>
        <div class="questionnaire-section-content-domain">
          <div class="questionnaire-section-content-domain-name">Compréhension Orale</div>
          <div class="questionnaire-section-content-domain-time">8 questions</div>
        </div>
      </div>

      <div class="questionnaire-section-action">
        <div class="questionnaire-section-action-button">
          <button :disabled="isDisabled" class="btn btn-primary btn-block" @click="emit('debuter', domainId)">
            <span>Commencer le test</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import {useRouter} from 'vue-router';
import UserService from "@/services/user.service";
import RouteEnum from "@/router/RouteEnum";

const router = useRouter();
const isTestAudioVisible = ref(false);
const time = ref(45);
const domainId = 1;

const props = defineProps({
  isDisabled: Boolean
});

const emit = defineEmits(['debuter']);

onMounted(() => {
  UserService.getUserTestContent().then(
      (response) => {
        const test = response.data.expression;
        const thirdTime = response.data.thirdtime;
        if (thirdTime) {
          time.value *= 1.33;
          time.value = Math.ceil(time.value);
        }
        if (test != null) router.push({name: RouteEnum.CANDIDACY_TESTS});
      },
  );
});

const playSound = () => {
  const audioInstance = new Audio(require('@/assets/sounds/Q1 option 1_48kHz.mp3'));
  audioInstance.play();
};
</script>
